export default __webpack_public_path__ + "static/Google_Gemini_logo_2025-21c195f4596390a82159b3500b1f3d1b.svg";